import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

var loaderStyle = {
  position: 'absolute',
  display: 'flex',
  zIndex: 2,
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
};

export default function CircularIndeterminate() {
  return (
    <div style={loaderStyle}>
      <BeatLoader color="#f15a29" size={15} />
    </div>
  );
}